package org.tlsys.file

const val FILE_SERVICE_INVOCATOR = "File Admin Extension"

const val FILE_SERVICE = "file_service"